<template>
  <loading-layout v-if="isRetrievingCompanyProfile" />
  <div v-else class="lg:pl-56">
    <div :class="['sidenav', mobileOpen]">
      <div class="flex flex-col items-center justify-start py-3">
        <logo size="sm" :inverted="true" class="nav_space-m" />
        <UserMainNavigation @close-sidenav="closeNav()" />
      </div>
      <app-info />
    </div>
    <div
      id="main-wrapper"
      class="w-full h-full min-h-screen max-w-full flex flex-col flex-grow transition bg-secondary-light dark:bg-gray-800"
    >
      <div class="flex flex-col flex-1 w-full h-full">
        <UserProgressAuth />
        <UserMainHeader @open-sidenav="openNav()" />
        <UserMainView />
      </div>
    </div>
    <a v-show="false" id="downloadFile" href="#"></a>
    <async-task-tracker
      v-if="isAsyncTaskTrackerVisible"
      id="global-async-task-tracker"
      @close="$store.dispatch('asyncTasksTracker/setVisibility', false)"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import DatePicker from 'vue2-datepicker'
// import DatePicker2 from 'v-calendar/lib/components/date-picker.umd'
//import Hammer from 'hammerjs'
import Logo from '@/components/shared/Logo.vue'
import AppInfo from '@/components/shared/AppInfo.vue'
import {
  UserMainNavigation,
  UserProgressAuth,
  UserMainHeader,
  UserMainView,
} from '@/components/layouts/partials'
import LoadingLayout from '@/components/layouts/LoadingLayout.vue'
import AsyncTaskTracker from '@/components/shared/AsyncTaskTracker.vue'
import 'vue2-datepicker/index.css'
import {Icon} from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import 'esri-leaflet-geocoder/dist/esri-leaflet-geocoder.css'

Vue.use(DatePicker)
// Vue.component('date-picker2', DatePicker2)

// delete Hammer.defaults.cssProps.userSelect

delete Icon.Default.prototype._getIconUrl

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  mounted() {
    // Touch gesture on mobile
    // const main = document.getElementById('main-wrapper')
    // const hammerMain = new Hammer(main)
    // hammerMain.on('tap press swipeleft', this.closeNav)
    // hammerMain.on('swiperight', this.openNav)
    // this.$once('hook:beforeDestroy', function () {
    //   hammerMain.off('swiperight tap press swipeleft')
    // })
    this.$store.dispatch('asyncTasksTracker/clearCompletedTasks')
    this.$store.dispatch('asyncTasksTracker/setVisibility',false)

  },
  data() {
    return {
      isOpenMobileNav: false,
      reactive: {
        value: 'Hello there',
      },
    }
  },
  methods: {
    openNav() {
      this.isOpenMobileNav = true
    },
    closeNav() {
      this.isOpenMobileNav = false
    },
  },
  computed: {
    isRetrievingCompanyProfile() {
      return this.$store.getters['auth/isChangingCompanyProfile']
    },
    mobileOpen() {
      return this.isOpenMobileNav ? 'open' : ''
    },
    isAsyncTaskTrackerVisible() {
      return this.$store.getters['asyncTasksTracker/visible']
    },
  },
  components: {
    Logo,
    AppInfo,
    UserMainNavigation,
    UserProgressAuth,
    UserMainHeader,
    UserMainView,
    LoadingLayout,
    AsyncTaskTracker,
  },
}
</script>

<style scoped>
.sidenav {
  @apply fixed flex flex-col justify-between h-full left-0 top-0 w-56;

  background: radial-gradient(
    circle at 100% 0%,
    theme('colors.primary.DEFAULT'),
    theme('colors.primary.light')
  );
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  pointer-events: auto;
  top: 0;
  left: 0;
  -webkit-overflow-scrolling: touch;
  z-index: 1999;
  transition: all 0.4s cubic-bezier(0.4, 0, 0, 1);
  transform: translate(-280px, 0);
}

.sidenav.open {
  transform: translate(0, 0);
}

@screen lg {
  .sidenav {
    @apply fixed flex flex-col justify-between h-full left-0 top-0 w-56;

    z-index: 1998;
    transition: none;
    transform: translate(0, 0);
  }
}

#global-async-task-tracker {
  position: fixed;
  right: 1%;
  bottom: 1%;
  z-index: 9999;
}
</style>
